import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/annual", label: "年度盘点" },
  { to: "/monthly", label: "月度总结" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || open;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <nav
        className={`transition-colors duration-300 ${
          solid ? "bg-background-50/90 backdrop-blur border-b border-background-200/70" : "bg-transparent border-b border-transparent"
        }`}
        aria-label="主导航"
      >
        <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-wifi-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-display text-lg text-primary-600">吃瓜榜单</span>
          </Link>

          <div className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-100/80 text-primary-700 font-semibold"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden md:block">
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-foreground-950 hover:bg-accent-600 transition-colors"
            >
              <i className="ri-arrow-right-up-line mr-1" aria-hidden="true"></i>
              投稿瓜线索
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 md:hidden"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm ${
                      isActive ? "bg-primary-100/80 text-primary-700 font-semibold" : "text-foreground-800 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                className="mt-2 flex items-center justify-center whitespace-nowrap rounded-full bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950"
              >
                <i className="ri-arrow-right-up-line mr-1" aria-hidden="true"></i>
                投稿瓜线索
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}